import React from 'react';
import moment from 'moment';
import styles from './style.css';

const RDFSelectionLegal = () => {
  return (
    <div className="legal-container">
      <div className="legal">
        <p>
          <strong>
            The principal value of the Retirement Funds is not guaranteed at any
            time, including at or after the target date, which is the
            approximate year an investor plans to retire (assumed to be age 65)
            and likely stop making new investments in the fund. If an investor
            plans to retire significantly earlier or later than age 65, the
            funds may not be an appropriate investment even if the investor is
            retiring on or near the target date. The funds&apos; allocations
            among a broad range of underlying T. Rowe Price stock and bond funds
            will change over time. The funds emphasize potential capital
            appreciation during the early phases of retirement asset
            accumulation, balance the need for appreciation with the need for
            income as retirement approaches, and focus on supporting an income
            stream over a long-term postretirement withdrawal horizon. The funds
            are not designed for a lump-sum redemption at the target date and do
            not guarantee a particular level of income. The funds maintain a
            substantial allocation to equities both prior to and after the
            target date, which can result in greater volatility over shorter
            time horizons.
          </strong>
        </p>
        <p>
          <strong>
            Current performance may be lower or higher than the quoted past
            performance, which cannot guarantee future results. Share price,
            principal value, and return will vary and you may have a gain or
            loss when you sell your shares.
          </strong>{' '}
          Average annual total return figures include changes in principal
          value, reinvested dividends, and capital gain distributions. All
          investments are subject to risk, including the possible loss of
          principal.
        </p>
        <p>
          <strong>
            Consider the investment objectives, risks, and charges and expenses
            carefully before investing. For a prospectus or, if available, a
            summary prospectus containing this and other information, visit
            troweprice.com. Read it carefully.
          </strong>
        </p>
        <p>
          Source for Morningstar data: &copy;{' '}
          {moment.parseZone().format('YYYY')} Morningstar, Inc. All Rights
          Reserved. The information contained herein: (1) is proprietary to
          Morningstar and/or its content providers; (2) may not be copied or
          distributed; and (3) is not warranted to be accurate, complete or
          timely. Neither Morningstar nor its content providers are responsible
          for any damages or losses arising from any use of this information.
          Past performance is no guarantee of future results.
        </p>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RDFSelectionLegal;
